var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-input-select',{attrs:{"fullwidth":"","label":this.$t('common.integration'),"loading":_vm.integrationsMeta.loading,"options":_vm.integrationOptions,"value":_vm.value},on:{"input":_vm.handleIntegrationSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }